import styled from 'styled-components';

export const FooterContainer = styled.div`
  font-family: ${({ theme }) => theme.fonts.workSans};
  display: flex;
  flex-direction: column;

  gap: 1.5rem;

  padding: 1.5rem;
`;

export const FooterTitle = styled.span`
  font-weight: 600;
  font-size: 2rem;
  line-height: 40px;
  font-family: 'Source Sans Pro';
  color: ${({ theme }) => theme.colors.grayDark3};
`;

export const FooterBoxWrapper = styled.div`
  display: flex;

  gap: 1.5rem;
`;

export const FooterBox = styled.div`
  display: flex;
  flex-direction: column;

  gap: 0.75rem;

  background-color: ${({ theme }) => theme.colors.white};
  padding: 1.5rem;
`;

export const FooterBoxTitle = styled.span`
  color: ${({ theme }) => theme.colors.grayDark4};
`;

export const FooterBoxSubtitle = styled.span<{ email?: boolean }>`
  font-weight: 600;
  color: ${({ theme, email }) =>
    email ? theme.colors.blue6 : theme.colors.grayDark4};
  text-decoration: ${({ email }) => (email ? 'underline' : 'none')};
  cursor: ${({ email }) => (email ? 'pointer' : 'none')};
`;

export const FooterBoxLink = styled.a`
  font-weight: 600;
  cursor: pointer;

  &,
  :visited,
  :link,
  :active {
    color: ${({ theme }) => theme.colors.blue6};
    text-decoration: underline;
  }
`;
